class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = document.querySelector('.cart-notification-overlay');
    this.onOverlayClick = this.handleOverlayClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.querySelectorAll('.cart-close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    document.querySelectorAll('.cart-open').forEach((openButton) =>
      openButton.addEventListener('click', this.open.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.style.overflow = 'hidden';

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    this.overlay.addEventListener('click', this.onOverlayClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.style.overflow = 'auto';

    this.overlay.removeEventListener('click', this.onOverlayClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {        
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-header',
        section: 'main-cart-header',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-recommendations',
        section: 'main-cart-recommendations',
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.js-contents',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleOverlayClick(evt) {
    if (evt.target == this.overlay) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
